import { Dispatch, SetStateAction, useCallback } from "react";
import "react-phone-number-input/style.css";
import { FAMILY_NAME_KEY, GIVEN_NAME_KEY } from ".";
import { EventTracker } from "../../../../Atoms/Analytics";
import TextInputDelay from "../../../../Atoms/TextInputDelay";
import { Text } from "../../../../Atoms/Typography";
import styles from "../../Checkout.module.scss";
import { RequiredMarker } from "./RequiredMarker";

export type FullName = {
  givenName: string;
  familyName: string;
};

type NameInputProps = {
  header?: string;
  fullName: FullName;
  setFullName: Dispatch<SetStateAction<FullName>>;
  trackEvents: Record<
    string,
    {
      category: string;
      action: string;
      label: string;
    }
  >;
};

export default function NameInput({
  header,
  fullName,
  setFullName,
  trackEvents,
}: NameInputProps) {
  const { givenName, familyName } = fullName;
  const setPartialName = useCallback(
    (partialName: Partial<FullName>) =>
      setFullName((fullName) => ({ ...fullName, ...partialName })),
    [setFullName]
  );

  return (
    <div>
      <Text size="small" muted={true}>
        {header}
      </Text>
      <div className={styles.BookingFormFieldsetField}>
        <label htmlFor="fname">
          First Name {!givenName && <RequiredMarker />}
        </label>
        <EventTracker onBlur={trackEvents[GIVEN_NAME_KEY]}>
          <TextInputDelay
            id="fname"
            name="fname"
            required={!givenName}
            value={givenName}
            type="text"
            autoComplete="fname"
            placeholder={"First Name"}
            onValueChange={(givenName) => setPartialName({ givenName })}
          />
        </EventTracker>
      </div>
      <div className={styles.BookingFormFieldsetField}>
        <label htmlFor="lname">
          Last Name {!familyName && <RequiredMarker />}
        </label>
        <EventTracker onBlur={trackEvents[FAMILY_NAME_KEY]}>
          <TextInputDelay
            id="lname"
            name="lname"
            required={!familyName}
            type="text"
            autoComplete="lname"
            value={familyName}
            placeholder={"Last Name"}
            onValueChange={(familyName) => setPartialName({ familyName })}
          />
        </EventTracker>
      </div>
    </div>
  );
}
